module.exports = __webpack_public_path__ + "static/media/YM39_2.6257c9ff.jpg";